'use strict';

exports.BucketAggregationBase = require('./bucket-aggregation-base');
exports.HistogramAggregationBase = require('./histogram-aggregation-base');
exports.RangeAggregationBase = require('./range-aggregation-base');
exports.TermsAggregationBase = require('./terms-aggregation-base');
exports.SignificantAggregationBase = require('./significant-aggregation-base');

exports.AdjacencyMatrixAggregation = require('./adjacency-matrix-aggregation');
exports.ChildrenAggregation = require('./children-aggregation');
exports.CompositeAggregation = require('./composite-aggregation');
exports.DateHistogramAggregation = require('./date-histogram-aggregation');
exports.AutoDateHistogramAggregation = require('./auto-date-histogram-aggregation');
exports.VariableWidthHistogramAggregation = require('./variable-width-histogram-aggregation');
exports.DateRangeAggregation = require('./date-range-aggregation');
exports.DiversifiedSamplerAggregation = require('./diversified-sampler-aggregation');
exports.FilterAggregation = require('./filter-aggregation');
exports.FiltersAggregation = require('./filters-aggregation');
exports.GeoDistanceAggregation = require('./geo-distance-aggregation');
exports.GeoHashGridAggregation = require('./geo-hash-grid-aggregation');
exports.GeoHexGridAggregation = require('./geo-hex-grid-aggregation');
exports.GeoTileGridAggregation = require('./geo-tile-grid-aggregation');
exports.GlobalAggregation = require('./global-aggregation');
exports.HistogramAggregation = require('./histogram-aggregation');
exports.IpRangeAggregation = require('./ip-range-aggregation');
exports.MissingAggregation = require('./missing-aggregation');
exports.NestedAggregation = require('./nested-aggregation');
exports.ParentAggregation = require('./parent-aggregation');
exports.RangeAggregation = require('./range-aggregation');
exports.RareTermsAggregation = require('./rare-terms-aggregation');
exports.ReverseNestedAggregation = require('./reverse-nested-aggregation');
exports.SamplerAggregation = require('./sampler-aggregation');
exports.SignificantTermsAggregation = require('./significant-terms-aggregation');
exports.SignificantTextAggregation = require('./significant-text-aggregation');
exports.TermsAggregation = require('./terms-aggregation');
